import styled from '@emotion/styled';

import Link from '@/components/Link';

const CallToActionButton = styled(Link.Button)`
  padding: 12px;
  border: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1.5px;
`;

export default CallToActionButton;
